module.exports = __webpack_public_path__ + "static/media/arrowcurcle.9f041144.svg";